import algoliasearchHelper from 'algoliasearch-helper';

import type { AlgoliaHit } from '@/productDiscovery/HeaderLeonidas/modules/productSuggestions/interfaces/algoliaResponse';
import { SponsoredProduct } from '@/productDiscovery/Listings/sponsoredProducts/interfaces/sponsoredProduct';

export function toAlgoliaHitWithSponsoredData(
  sponsoredProductSuggestions: algoliasearchHelper.SearchResults<AlgoliaHit>,
  sponsoredProducts: SponsoredProduct[],
  sponsoredProductsPositions: number[],
) {
  return sponsoredProductSuggestions.hits.map((hit: AlgoliaHit) => {
    const sp = sponsoredProducts.find(
      ({ productId }) => productId === parseInt(hit.objectID, 10),
    );
    return (
      sp && {
        ...hit,
        isSponsored: true,
        position: getSponsoredProductPosition(
          hit,
          sponsoredProducts,
          sponsoredProductsPositions,
        ),
        adPayer: sp.adPayer,
        cpc: sp.cpc,
        adTrackingData: sp.adTrackingData,
      }
    );
  });
}
const getSponsoredProductPosition = (
  product: AlgoliaHit,
  sponsoredProductsConfig: SponsoredProduct[] = [],
  sponsoredProductsPositions: number[] = [],
): number | null => {
  const index = sponsoredProductsConfig.findIndex(
    ({ productId }) => productId === parseInt(product.objectID, 10),
  );

  return sponsoredProductsPositions[index] || null;
};
